<!--  -->
<template>
  <user-center-wrap>
    <div class="guessing-management-up">
      <div class="anchor-titles">
        <div :class="{ active: active=='question' }" class="title" @click="changeActive('question')">
          <img src="../../assets/img/center-anchor/data_overview_on.png" alt="" v-if="active=='question'" />
          <img src="../../assets/img/center-anchor/data_overview_nor.png" alt="" v-else />
          <span>预设问题</span>
        </div>
        <div :class="{ active: active=='record' }" class="title" @click="changeActive('record')">
          <img src="../../assets/img/center-anchor/my_fans_on.png" alt="" v-if="active=='record'" />
          <img src="../../assets/img/center-anchor/my_fans_nor.png" alt="" v-else />
          <span>开奖记录</span>
        </div>
      </div>
    </div>
		
		<div class="guessing-anchor">
			<Management v-if="active=='question'"></Management>
			<Record v-if="active=='record'"></Record>
		</div>

	</user-center-wrap>
</template>


<script>
import UserCenterWrap from "../../components/user-center-wrap/user-center-wrap";
import Management from "@/components/guessing/management"
import Record from "@/components/guessing/record"
import { post } from "@/util/http";
import { mapState, mapMutations } from "vuex"
export default {
	name: "guessing-management",
	components: { 
		UserCenterWrap,
		Management,
		Record
	},
	data() {
		//这里存放数据
		return {
			active: "question"
		};
	},
	computed: {
		...mapState(["userInfo"]),
	},
	created() {
		this.getUserInfo();
		/*
		if(this.userInfo &&this.userInfo.id&&this.userInfo.is_guess_host==1){
			
		}else{
			this.$router.push("/")
		}
		*/
	},
	mounted() {

	},
	

	//监控data中的数据变化
	watch: {
		
	},
	//方法集合
	methods: {
		changeActive(v=""){
			this.active = v;
		},
		async getUserInfo() {
		  const { data } = await post({
		    url: "/api/user/getUserInfo",
		  });
		  if (data.status == 0) {
		    let { mobile = "",is_guess_host="" } = data.data;
				if(is_guess_host!=1){
					this.$router.push("/")
				}
		  }
		},
	},
	
	//如果页面有keep-alive缓存功能，这个函数会触发
	activated() {
		
	}, 
}
</script>
<style scoped lang="stylus">

.guessing-management-up {
  background-color: #fff;
  flex: 1;
  .anchor-titles {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 1.3rem;
    .title {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      border-right: 0.01rem solid #f0f0f0;
      cursor: pointer;
      &:last-child {
        border-right: none;
      }
      img {
        width: 0.36rem;
        height: 0.36rem;
        margin-bottom: 0.12rem;
      }
      span {
        font-size: 0.16rem;
        line-height: 0.22rem;
        font-weight: 500;
      }
    }
    .active {
      span {
        font-weight: 600;
      }
    }
  }


}
.guessing-anchor{
	background-color: #fff;
	border-top: 0.08rem solid #f4f4f4;
	padding: 0.3rem 0.44rem 0.44rem;
	flex: 1;
}
</style>